import { render, staticRenderFns } from "./SGPContadorRecarregamentoComponent.vue?vue&type=template&id=32578ad6"
import script from "./SGPContadorRecarregamentoComponent.vue?vue&type=script&lang=js"
export * from "./SGPContadorRecarregamentoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports